import { isNil } from 'lodash';

const serializedField = value => {
    if (isNil(value) || typeof value === 'string') {
        return value;
    }
    try {
        return JSON.stringify(value);
    } catch (e) {
        console.error(e);
        return e.message;
    }
};

export const serializeAppEvent = event => {
    const serializedEvent = { ...event };

    serializedEvent.value = serializedField(event.value);
    serializedEvent.prevValue = serializedField(event.prevValue);
    serializedEvent.data =
        typeof event.data === 'string'
            ? { rawData: JSON.stringify({ stringContent: event.data }) }
            : isNil(event.data)
            ? { rawData: JSON.stringify({}) }
            : { rawData: serializedField(event.data), ...event.data };

    return serializedEvent;
};
